// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BKz_","content":"styles_content__2PbwO","tableWrap":"styles_tableWrap__1DMfN"};